import React from 'react';
import { Modal } from 'react-bootstrap';
import './ViewInMap.scoped.scss';
import Button from '../../button/Button';

const ViewInMap = ({showMapsModal, setShowMapsModal, generateGoogleMapsUrl, generateAppleMapsUrl}) => {

    return (
        <Modal className='open-map' show={showMapsModal} onHide={() => setShowMapsModal(false)}>
                <Modal.Header closeButton>
                    <h5>Which App would you like to open this Venue in?</h5>
                </Modal.Header>
                <Modal.Body>
                <a className='map-link' href={generateGoogleMapsUrl()} target="_blank" rel="noopener noreferrer">Google Maps</a>
                <a className='map-link' href={generateAppleMapsUrl()} target="_blank" rel="noopener noreferrer">Apple Maps</a>
                </Modal.Body>
            </Modal>
    );
}
export default ViewInMap